import React from 'react';
import { Alert, Col, Container, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { SignerModel } from 'app/shared/digital-signature/digital-signature.model';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { fetchSignersQuery } from 'app/shared/digital-signature/signer-list-modal.queries';

interface SignerListModalProps {
  entity: string;
  idEntity: number;
  onClose: Function;
}

const SignerListModal = (props: SignerListModalProps) => {
  const { data: signerList, isLoading: signerListLoading } = fetchSignersQuery(props.entity, props.idEntity);

  const renderTableRow = (item: SignerModel, index: number) => {
    return (
      <tr>
        <td>
          <span>{item.name}</span>
        </td>
        <td>
          <span>{item.institution}</span>
        </td>
      </tr>
    );
  };

  return (
    <Modal centered scrollable isOpen size={'l'}>
      <ModalHeader close={<FontAwesomeIcon className={'hand'} icon={faXmark} />} onClick={e => props.onClose()} className={'d-flex'}>
        <span>Potpisi</span>
      </ModalHeader>
      <ModalBody>
        <Container>
          <Row>
            <Col xs={12}>
              {signerList?.length !== 0 ? (
                <ViewTable
                  dataLength={!signerListLoading ? signerList.length : 0}
                  renderTableRow={renderTableRow}
                  tableData={!signerListLoading ? signerList : []}
                >
                  <ViewTableHeaderColumn renderSort={false} columnLabels={['Potpisnik']} />
                  <ViewTableHeaderColumn renderSort={false} columnLabels={['Institucija']} />
                </ViewTable>
              ) : (
                <Alert color="info" className="uniform-width">
                  Nema evidentiranih potpisa.
                </Alert>
              )}
            </Col>
          </Row>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default SignerListModal;
